import HubModule from './HubModule'

export default HubModule
